import queryString from 'query-string';

import { appConfig } from '@config';
import axiosInstance from '@helpers/api/axiosInstance';
import failErrorResponse from '@helpers/api/httpResponse';
import { setHeaders } from '@helpers/api/setHeaders';
import successResponse from '@helpers/api/successResponse';

/**
 * GET request
 * @param {string} path - URL path
 * @param {Object<*,*>} queryObject - Query object used to construct query search parameters
 * @param {Object} [$2={}] - Configuration options.
 * @param {string} [$2.baseURL] - Base URL overrides default.
 * @param {Function} [$2.onSuccess=()=>{})] - Onsuccess callback overrides default successResponse
 * @param {Function} [$2.onFailure=failErrorResponse] - Callback on failure. Defaults to standard reject handler
 * @param {Object<string,string>|{}} [$2.additionalHeaders] - Pass additional headers which can overwrite current values
 * @param {Object<string,*>|{}} [$2.axiosOptions] - Extra axios config options
 * @returns {Promise<*>}
 */
const getRequest = (
  path,
  queryObject = {},
  {
    baseURL = `${appConfig.apiUrl}/`,
    onSuccess = successResponse,
    onFailure = failErrorResponse,
    additionalHeaders = {},
    axiosOptions = {},
  } = {}
) =>
  axiosInstance
    .get(`${baseURL}${path}`, {
      params: queryObject,
      paramsSerializer: params => queryString.stringify(params, { arrayFormat: 'comma' }),
      headers: setHeaders(additionalHeaders),
      ...axiosOptions,
    })
    .then(onSuccess)
    .catch(onFailure);

export default getRequest;
